import { Scripts } from 'src/presentation/pages'

export const makeScripts = () => <Scripts />
